<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
    <mat-card-header>
        @if(isProcessing){
            <div style="margin-bottom:30px;width:100%;">
                <app-processing-banner [WaitMessage]="processingMessage" style="width:100%"></app-processing-banner>
            </div>
        }
    </mat-card-header>

    <mat-card-content>
        <span style="margin-left: 0px;margin-top:20px;"  class="ace-heading-text-level-2">Configure PARCS Settings</span>

        @if(selectedPARCS !== '' || undefined){
            <br /><br /><span class="ace-heading-text-level-2">Selected PARCS: {{selectedPARCS}}</span>
        }
        <mat-stepper linear="true" #stepper>
            <mat-step [stepControl]="parcsLocationForm" label="Enter Flash Location Id" [editable]="isActivationInProgress">
                <form [formGroup]="parcsLocationForm">
                    <div class="row">
                    <div class="col-6">
                            <mat-form-field style="width:98%;">
                                <mat-label>Location Id</mat-label>
                                <input matInput formControlName="locationId" placeholder=""
                                    required>
                                <mat-error>The Location Id is rquired</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <div style="margin-top:30px;">

                            @if(locationIdError){
                                <span style="color:red;"><strong>This Location Id cannot be located.  Please try again.</strong></span>
                            } @else {
                                <span>Enter the Location Id to validate.</span>
                            }

                            </div>
                        </div>
                    </div>
                <div style="margin-top:10px;">
                    <button type="button" mat-raised-button color="primary" (click)="onParcsStepOne()">Next</button>
                </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="parcsTokenForm" label="Enter Flash Security Token" [editable]="isActivationInProgress">
                <form [formGroup]="parcsTokenForm">
                    <div class="row">
                        <div class="col-6">
                             <mat-form-field style="width:98%;">
                                <mat-label>Security Token</mat-label>
                                <input matInput formControlName="securityToken" placeholder=""
                                    required>
                                <mat-error>The Security Token is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                <div style="margin-top:10px;">
                    <button type="button" mat-raised-button color="primary" matStepperPrevious>Back</button>
                    <button type="button" mat-raised-button color="primary" (click)="onParcsStepTwo()">Next</button>
                </div>
                </form>
            </mat-step>
            <mat-step label="Review Flash Settings" [editable]="isActivationInProgress">
                <form [formGroup]="parcsReviewForm">
                    <div class="row">
                    <div class="col-4">
                            <mat-form-field style="width:98%;" appearance="outline">
                                <mat-label>Location Id</mat-label>
                                <input matInput [value]="parcsLocationForm.get('locationId')?.value" readonly="true">
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                             <mat-form-field style="width:98%;" appearance="outline">
                                <mat-label>Security Token</mat-label>
                                <input matInput [value]="parcsTokenForm.get('securityToken')?.value" readonly="true">
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-4">
                            <div style="margin-top:30px;">
                            <div style="margin-top:20px'">
                                <span>LPR Enabled Status: {{lprStatusText}}</span>
                            </div>
                            </div>
                        </div> -->
                    </div>
                <div>
                    <button type="button" mat-raised-button color="primary" matStepperPrevious>Back</button>
                    <button type="button" mat-raised-button color="primary" (click)="onSubmitFlashFacility()">Submit and Activate</button>
                </div>
                </form>
            </mat-step>
            <mat-step label="Flash Successfully Configured">
                <ng-template matStepLabel>Flash Successfully Configured!</ng-template>
                <p style="font-size:18px;font-weight:bold;">Flash has been successfully activated and configured.</p>
                <p style="font-size:18px;">Lot {{_appGeneralState.currentLotNumber}} Flash has been activated on Location Id <strong>{{this.parcsLocationForm.get('locationId')?.value?.trim()}}</strong></p>
                <div>
                </div>
            </mat-step>
        </mat-stepper>

    </mat-card-content>
</mat-card>
